import { ProgramVariables } from "./types";

export const programsKeys = {
  list: ["programs"],
  getOne: (programIdentifier: string) => ["programs", programIdentifier],
};

/**
 * Support deprecated string parameter
 * @param variables program variables
 * @returns a valid programIdentifier and optional query params
 */
export const getProgramVariables = (variables: ProgramVariables) => {
  if (typeof variables === "string") {
    return {
      programIdentifier: variables,
      params: undefined,
    };
  }

  return {
    programIdentifier: variables.programIdentifier,
    params: {
      offer_identifier: variables.offerIdentifier,
    },
  };
};
